import { Bot } from 'lucide-react';
import { Badge } from '@fiado/react-kit';
import type { TenantUserListItemLocal } from '../../api/types/TenantLocal';

/** Nombre del usuario en la tabla; un sistema (API) lleva ícono e insignia "API". */
export function DisplayNameCell({
    user,
}: {
    user: Pick<TenantUserListItemLocal, 'displayName' | 'accountType'>;
}) {
    if (user.accountType !== 'API') return <>{user.displayName}</>;
    return (
        <span className="inline-flex items-center gap-2">
            <Bot className="size-4 shrink-0 text-info" aria-label="Sistema" />
            {user.displayName}
            {/* El azul del kit sobre su tinte no llega a AA; `!` gana a su CSS sin capa. */}
            <Badge variant="info" className="bg-info/15! text-foreground! ring-1 ring-info/50">
                API
            </Badge>
        </span>
    );
}
